global.conmed = global.conmed || {};

conmed.panelContainer = function ($) {
    'use strict';
    var that = {
        selectors: {
            selectedTag: '#SelectedTag',
            videoItem: '.video-item',
            modal: '.panel-container-modal .modal',
            modalCloseBtn: '.panel-container-modal .btn-close',
            modalVideo: '#modal-video'
        }
    };

    that.init = function () {

        $(that.selectors.selectedTag).on('change', function (e) {
            e.preventDefault();
            FilterVideos();
        });

        function FilterVideos() {
            var selectedTag = $(that.selectors.selectedTag).children("option:selected").val();

            var pathname = window.location.pathname;
            var url = window.location.href;
            var origin = window.location.origin;

            var filter = "";
            var tagFilter = "";

            if (selectedTag !== "" && selectedTag !== undefined)
                tagFilter = 'tag=' + selectedTag + '&';

            filter = '?' + tagFilter;

            window.location = origin + pathname + removeTrailingAmpersand(filter);

        }

        function removeTrailingAmpersand(str) {
            if (str.endsWith('&')) {
                return str.slice(0, -1);
            }
            return str;
        }

        var myPlayer

        $(that.selectors.videoItem).on('click', function (e) {
            e.preventDefault();
            var wistiaVideoId = $(this).data('video-id');
            var componentID = $(this).data('component-id');
            var modalSelector = '[data-component-id="' + componentID + '"]';
            
            
            var scriptUrl = "https://fast.wistia.com/embed/" + wistiaVideoId + ".js";
            let video = scriptUrl + 
               `<div class="two-up-container-feature-item" style="width:100%;">
                    <div class="">
                        <div>
                            <script src="@scriptUrl" async type="module"></script>
                            <script src="https://fast.wistia.com/player.js" async></script>
                            <script src="https://fast.wistia.com/assets/external/transcript.js" async></script>
                            <wistia-player media-id="${wistiaVideoId}" player-color="0099db" big-play-button="false" rounded-player="5" fullscreen-control="true"></wistia-player>
                            <div style="display:none">
                            <wistia-transcript media-id="${wistiaVideoId}"></wistia-transcript>
                            </div>
                        </div>
                    </div>
                </div>`

            if ($(that.selectors.modalVideo + modalSelector).html() != '') {
                $(that.selectors.modalVideo + modalSelector).html(video);
            }
            else {

                $(that.selectors.modalVideo + modalSelector).html(video);
            }

            $(that.selectors.modal + modalSelector).delay(100).fadeIn(0);

        });

        $(that.selectors.modalCloseBtn).on('click', function (e) {
            e.preventDefault();
            $(that.selectors.modal).hide();

            var x = 0;

            // +++  Determine the available player IDs +++//
            for (x = 0; x < Object.keys(videojs.players).length; x++) {

                // Assign the player name to setPlayer
                var setPlayer = Object.keys(videojs.players)[x];

                // Define the ready event for the player
                videojs.getPlayer(setPlayer).pause();
            }
        });

        $(that.selectors.modal).on('click', function (e) {
            e.preventDefault();
            if (e.target.className === 'container-fluid p-0'){
                $(that.selectors.modal).hide();

                var x = 0;
                // +++  Determine the available player IDs +++//
                for (x = 0; x < Object.keys(videojs.players).length; x++) {

                    // Assign the player name to setPlayer
                    var setPlayer = Object.keys(videojs.players)[x];

                    // Define the ready event for the player
                    videojs.getPlayer(setPlayer).pause();
                }
            }
            
        });
    };

    return that;
}(jQuery);